module.exports = "<div class=\"whole-page\">\n  <section>\n    <router-outlet></router-outlet> \n  </section>\n</div>\n"